import React from "react";
import "./CommunityContributions.css";
const CommunityContributions = () => {
  return (
    <div>
      <h1>
        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Autem, quia.
      </h1>
    </div>
  );
};

export default CommunityContributions;
